var _g, _path, _path2, _path3, _path4, _path5, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlannerHousingTradelifeIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 107,
    height: 107,
    viewBox: "0 0 107 107",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_0_1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M103 49.5C103 76.8381 80.8381 99 53.5 99C26.1619 99 4 76.8381 4 49.5C4 22.1619 26.1619 0 53.5 0C80.8381 0 103 22.1619 103 49.5Z",
    fill: "#B7BF10"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M69.817 71.0317C61.9469 70.3456 54.0318 70.3456 46.1617 71.0317C44.711 71.1329 43.2777 70.6679 42.1645 69.7351L25.8269 56.0306C25.655 55.8879 25.521 55.7052 25.4366 55.4986C25.3523 55.292 25.3202 55.068 25.3432 54.8461C25.3661 54.6243 25.4435 54.4115 25.5684 54.2265C25.6933 54.0415 25.862 53.8899 26.0595 53.7852H26.1229C27.593 53.0959 29.2301 52.8399 30.8413 53.0472C32.4525 53.2545 33.9707 53.9166 35.2171 54.9554L43.8353 61.5967",
    stroke: "white",
    strokeWidth: 2.01,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M57.5614 61.5968L46.3947 62.5456C45.5698 62.6045 44.7544 62.3399 44.1223 61.8082C43.4902 61.2766 43.0914 60.5198 43.0108 59.6993V59.6993C42.9489 58.8752 43.213 58.0596 43.7466 57.4272C44.2802 56.7948 45.0409 56.3957 45.866 56.3153L53.8709 55.6301C55.5844 55.4639 57.2481 54.9624 58.7669 54.1542C63.6629 51.6664 70.6421 54.4705 75.4324 58.5291",
    stroke: "white",
    strokeWidth: 2.01,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M77.8537 78.9803L69.394 75.2485C69.294 75.203 69.2124 75.1251 69.1624 75.0275C69.1125 74.9299 69.0972 74.8182 69.1191 74.7108C70.5694 67.6619 73.5111 61.0024 77.7479 55.1767C77.8142 55.0815 77.9119 55.0125 78.024 54.9817C78.136 54.9509 78.2554 54.9602 78.3612 55.008L86.8209 58.7293C86.9759 58.7986 87.0973 58.9259 87.1587 59.0838C87.22 59.2417 87.2165 59.4174 87.1487 59.5727L78.6891 78.6535C78.6557 78.7297 78.6077 78.7985 78.5477 78.8562C78.4877 78.9138 78.4168 78.9591 78.3393 78.9894C78.2617 79.0198 78.1789 79.0346 78.0956 79.033C78.0122 79.0315 77.93 79.0135 77.8537 78.9803V78.9803Z",
    stroke: "white",
    strokeWidth: 2.01,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M80.7726 61.1119C80.7726 61.2141 80.7422 61.3139 80.6853 61.3989C80.6284 61.4838 80.5474 61.55 80.4528 61.5891C80.3581 61.6282 80.2539 61.6384 80.1534 61.6185C80.0529 61.5986 79.9606 61.5494 79.8881 61.4771C79.8156 61.4049 79.7663 61.3129 79.7463 61.2127C79.7263 61.1125 79.7366 61.0086 79.7758 60.9142C79.815 60.8198 79.8814 60.7391 79.9666 60.6824C80.0518 60.6256 80.152 60.5953 80.2545 60.5953C80.3919 60.5953 80.5237 60.6498 80.6209 60.7466C80.718 60.8435 80.7726 60.9749 80.7726 61.1119Z",
    stroke: "white",
    strokeWidth: 2.01,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M63.0498 52.6256V38.3835C63.0484 38.3148 63.0608 38.2465 63.0862 38.1826C63.1116 38.1187 63.1496 38.0605 63.1978 38.0114C63.2461 37.9623 63.3037 37.9233 63.3672 37.8967C63.4308 37.8701 63.499 37.8564 63.568 37.8564H68.0728C68.1841 37.8556 68.2925 37.8211 68.3838 37.7574C68.475 37.6938 68.5447 37.6041 68.5837 37.5001C68.6227 37.3961 68.6291 37.2828 68.602 37.1751C68.575 37.0675 68.5158 36.9705 68.4323 36.8971L62.1933 31.6262C62.1483 31.5812 62.1218 31.521 62.1193 31.4575V22.4336C62.1193 22.333 62.0792 22.2364 62.0078 22.1653C61.9364 22.0941 61.8396 22.0541 61.7386 22.0541H55.986C55.8851 22.0541 55.7882 22.0941 55.7169 22.1653C55.6455 22.2364 55.6054 22.333 55.6054 22.4336V25.8703C55.606 25.8889 55.6011 25.9072 55.5913 25.923C55.5816 25.9389 55.5674 25.9515 55.5505 25.9594C55.5336 25.9672 55.5147 25.97 55.4963 25.9673C55.4779 25.9645 55.4606 25.9565 55.4467 25.9441L47.5793 19.2921C47.3603 19.1037 47.0807 19 46.7915 19C46.5022 19 46.2226 19.1037 46.0037 19.2921L25.1718 36.8971C25.0829 36.9671 25.0184 37.0632 24.9874 37.1719C24.9564 37.2805 24.9605 37.3961 24.9991 37.5023C25.0377 37.6084 25.1089 37.6998 25.2025 37.7634C25.2962 37.8269 25.4075 37.8595 25.5207 37.8564H30.0361C30.1735 37.8564 30.3053 37.9108 30.4025 38.0077C30.4996 38.1046 30.5542 38.236 30.5542 38.373V52.6256",
    stroke: "white",
    strokeWidth: 2.01,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_0_1",
    x: 0,
    y: 0,
    width: 107,
    height: 107,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_0_1"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_0_1",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlannerHousingTradelifeIcon);
export default __webpack_public_path__ + "static/media/planner-housing-tradelife-icon.599de5b10ef2436b4be0cba033a52cb9.svg";
export { ForwardRef as ReactComponent };